// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".folded:not(.unfolded) :host .nav-link>span{opacity:0;transition:opacity 200ms ease}.folded:not(.unfolded) :host.open .children{display:none !important}:host .nav-link .collapsable-arrow{transition:transform .3s ease-in-out,opacity .25s ease-in-out .1s;transform:rotate(0)}:host>.children{overflow:hidden}:host.open>.nav-link .collapsable-arrow{transform:rotate(90deg)}", ""]);
// Exports
module.exports = exports;


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();